<template>
  <div class="tab">
    <div class="tab_item" v-for="(item, index) in tabBarImg" :key="index" v-if="item.isFlag" @click="switchToTab(item.path)">
      <img :src="$route.path === item.path ? item.icon : item.normal" alt="" />
      <!-- <span :class="$route.path === item.path ? 'active' : ''">{{item.title}}</span> -->
    </div>
    <div class="tabbar" v-if="flagBadge">{{countDarft}}</div>
    <img src="../../assets/img/addIcon.png" alt="" class="tabImg" @click="addAppointment" v-show="flag" />
  </div>
</template>
<script type="text/javascript">
import {
  findDraftsCount
} from "@/axios/api";
export default {
  name: "Tabbar",
  data() {
    return {
      tabBarImg: [
        {
          path: '/index',
          normal: require('../../assets/icon/index.png'),
          icon: require('../../assets/icon/indexOk.png'),
          isFlag: true,
        },
        // {
        //   path: '/customer',
        //   normal: require('../../assets/icon/clientNo.png'),
        //   icon: require('../../assets/icon/clientOk.png'),
        //   isFlag: true,
        // },
        {
          path: '',
          normal: require('../../assets/img/part.png'),
          icon: require('../../assets/img/part.png'),
          isFlag: true,
        },
        // {
        //   path: '/reception',
        //   normal: require('../../assets/icon/clinicNo.png'),
        //   icon: require('../../assets/icon/clinicOk.png'),
        //   isFlag: true,
        // },
        {
          path: '/aboutUs',
          normal: require('../../assets/icon/own.png'),
          icon: require('../../assets/icon/owe.png'),
          isFlag: true,
        },
      ],
      flag: true,
      flagBadge: false,
      countDarft: '',
      areaType: localStorage.getItem('areaType'),
      doctorNo: ''
    }
  },
  created() {
    this.userStatus = JSON.parse(localStorage.getItem('userInfo')).status
    this.doctorNo = JSON.parse(localStorage.getItem('userInfo')).doctorNo
    if (this.userStatus == 1) {
      this.flag = false
      if (this.doctorNo != null) {
        this.tabBarImg[2].isFlag = true
      } else {
        this.tabBarImg[2].isFlag = false
      }
    } else if (this.userStatus == 0) {
      this.flag = true
      this.tabBarImg[2].isFlag = true
    }
    this.findCount()
  },
  methods: {
    addAppointment() {
      this.$router.push("/addAppointment");
    },
    // 统计草稿箱数量
    findCount() {
      this.empId = JSON.parse(localStorage.getItem('userInfo')).empId
      findDraftsCount({
        userId: this.empId,
        areaType: this.areaType,
        areaCode: this.areaType,
      })
        .then((res) => {
          // console.log(res.data);
          if (res.result == true) {
            let data = res.data
            this.countDarft = data
            if (this.countDarft != 0) {
              this.flagBadge = true
            }
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    switchToTab(path) {
      this.$router.replace(path);
    }
  }
}
</script>

<style type="text/css">
* {
  margin: 0;
  padding: 0;
}
.tab {
  width: 100%;
  height: 60px;
  display: flex;
  position: fixed;
  bottom: 0;
  background: #fff;
  z-index: 999;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.18);
  border-radius: 25px 25px 0 0;
}
.tab_item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
}
.tab_item img {
  width: 30px;
  height: 30px;
}
.active {
  color: blue;
}
.tabImg {
  width: 5rem;
  position: absolute;
  bottom: 1rem;
  left: 40%;
  z-index: 999999;
}
.tabbar {
  width: 1.25rem;
  height: 1.25rem;
  text-align: center;
  line-height: 1.25rem;
  background: #fff1f0;
  border-radius: 100%;
  font-size: 0.85rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ff4133;
  /* border: 1px solid red; */
  position: absolute;
  right: 5%;
  top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabbar.vue